export const USERS_GET = 'USERS_GET';
export const USER_ADD = 'USER_ADD';
export const USER_EDIT = 'USER_EDIT';
export const ROLES_ALL = 'ROLES_ALL';
export const USER_DELETE = 'USER_DELETE';
